// src/components/InvestmentTopUpModal.jsx
import React, { useState } from "react";

import api from "../services/api";

const InvestmentTopUpModal = ({ open, onClose, onSuccess, investment }) => {
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open || !investment) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    const numericAmount = Number(amount);
    if (!numericAmount || numericAmount <= 0) {
      alert("Enter a valid amount greater than zero.");
      return;
    }
    setLoading(true);
    try {
      await api.topUpInvestment({
        investmentId: investment.id,
        amount: numericAmount,
        note,
      });
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      console.error(error);
      alert(error?.message || "Failed to top up investment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 py-6">
      <div className="w-full max-w-md overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl">
        <form onSubmit={handleSubmit}>
          <div className="flex items-start justify-between border-b border-slate-200 px-6 py-4">
            <div>
              <h2 className="text-lg font-semibold text-slate-900">Top up investment</h2>
              <p className="text-xs text-slate-500">
                Add additional capital to {investment.name}. Funds will be debited from your wallet.
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded-full border border-slate-200 p-2 text-slate-500 hover:bg-slate-100"
              aria-label="Close"
            >
              &times;
            </button>
          </div>

          <div className="space-y-4 px-6 py-6">
            <div>
              <label className="block text-sm font-medium text-slate-600">Amount</label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={amount}
                onChange={(event) => setAmount(event.target.value)}
                className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-100"
                placeholder="0.00"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-600">Note (optional)</label>
              <input
                type="text"
                value={note}
                onChange={(event) => setNote(event.target.value)}
                className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-100"
                placeholder="e.g. Quarterly savings"
              />
            </div>
            <div className="rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-xs text-slate-600">
              <p>
                Top-ups participate from the date contributed. Interest is pro-rated for the remaining tenor and paid
                according to the plan&apos;s schedule.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-end gap-3 border-t border-slate-200 px-6 py-4">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-600 hover:bg-slate-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-emerald-700 disabled:opacity-70"
            >
              {loading ? "Processing..." : "Confirm top up"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InvestmentTopUpModal;

